import $ from 'jquery';
import Swiper from 'swiper';
import { EffectFade, Controller } from 'swiper/modules';
import { Breakpoint } from '../types/breakpoint';
import LazyImages from './lazy-images';
export default class BubblesSlider {
    static $slider = $('.js__bubbles-slider');
    static $contentSlider = $('.js__bubbles-content-slider');
    static slider;
    static contentSlider;
    static sliderOptions = {
        modules: [Controller, EffectFade],
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 22,
        loop: true,
        loopAdditionalSlides: 6,
        breakpoints: {
            [Breakpoint.md]: {
                spaceBetween: 74,
            },
        },
    };
    static contentSliderOptions = {
        modules: [Controller, EffectFade],
        effect: 'fade',
        fadeEffect: {
            crossFade: true,
        },
        loop: true,
        loopAdditionalSlides: 6,
        autoHeight: true,
        allowTouchMove: false,
    };
    static init() {
        if (!this.$slider.length || !this.$contentSlider.length) {
            return;
        }
        this.contentSlider = new Swiper(this.$contentSlider.get(0), {
            ...this.contentSliderOptions,
        });
        this.slider = new Swiper(this.$slider.get(0), {
            ...this.sliderOptions,
            controller: {
                control: this.contentSlider,
            },
        });
        LazyImages.update();
    }
}
